/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "normalize.css";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

//custom libraries
import "./i18n";
import { GlobalStyles } from "./styled-components/global-styling";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  CSRProvider,
  SelectedStoreProvider,
  MessageProvider,
  ProgressProvider,
} from "./context";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import Theme from "./themes";
import AppLoader from "./components/common/AppLoader";

ReactDOM.render(
  <React.StrictMode>
    {/* add spinner later */}
    <Suspense fallback={<AppLoader open={true} />}>
      <StylesProvider injectFirst>
        <StyledThemeProvider theme={Theme}>
          <MuiThemeProvider theme={Theme}>
            <GlobalStyles />
            <MessageProvider>
              <CSRProvider>
                <SelectedStoreProvider>
                  <ProgressProvider>
                    <App />
                  </ProgressProvider>
                </SelectedStoreProvider>
              </CSRProvider>
            </MessageProvider>
          </MuiThemeProvider>
        </StyledThemeProvider>
      </StylesProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
